import React from 'react';
import { Link } from 'react-router-dom';
import { Section } from '@/pages/LandingComplete';
import { Button } from '@/components/ui/button';
import { Gift, CheckCircle, ArrowRight } from 'lucide-react';

interface GiftVoucherContent {
  title?: string;
  titleHighlight?: string;
  subtitle?: string;
  features?: string[];
  ctaText?: string;
}

export function DynamicGiftVoucher({ content }: { content: GiftVoucherContent }) {
  const features = content.features || ['Flexibel einlösbar', '12 Monate gültig', 'Beliebiger Wert'];

  return (
    <Section className="bg-gradient-to-br from-red-50 via-orange-50 to-yellow-50">
      <div className="max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 rounded-full bg-red-100 px-5 py-2 text-red-700 font-semibold mb-6">
          <Gift className="h-5 w-5" />
          Geschenk-Tipp
        </div>
        
        <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-4">
          {content.title || 'Das perfekte'} <span className="text-red-600">{content.titleHighlight || 'Geschenk'}</span>
        </h2>
        
        <p className="text-xl text-slate-600 mb-8 max-w-2xl mx-auto">
          {content.subtitle || 'IT-Hilfe als Gutschein – ideal für Familie und Freunde'}
        </p>
        
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          {features.map((feature, i) => (
            <div key={i} className="flex items-center gap-2 bg-white rounded-full px-4 py-2 shadow-sm">
              <CheckCircle className="h-5 w-5 text-green-600" />
              <span className="text-slate-700 font-medium">{feature}</span>
            </div>
          ))}
        </div>
        
        <Link to="/gutschein">
          <Button className="bg-red-600 hover:bg-red-700 text-white px-8 py-6 text-lg font-bold rounded-xl shadow-lg">
            <Gift className="h-5 w-5 mr-2" />
            {content.ctaText || 'Gutschein kaufen'}
            <ArrowRight className="h-5 w-5 ml-2" />
          </Button>
        </Link>
      </div>
    </Section>
  );
}
